export default {
    topics: [
        {
            title: 'Basic classes',
            href: 'c-File.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4884',
            next: 'tocId-d66e4884',
        },
        {
            title: 'Network',
            href: 'c-FTP.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e5320',
            next: 'tocId-d66e5320',
        },
        {
            title: 'Database',
            href: 'c-DBEngine.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e5642',
            next: 'tocId-d66e5642',
        },
        {
            title: 'Application',
            href: 'c-Application.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e5804',
            next: 'tocId-d66e5804',
        },
        {
            title: 'Schema',
            href: 'c-Schema.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e5998',
            next: 'tocId-d66e5998',
        },
        {
            title: 'Document',
            href: 'c-Entity.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e6740',
            next: 'tocId-d66e6740',
        },
        {
            title: 'Workflow',
            href: 'c-WorkflowTask.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e6797',
            next: 'tocId-d66e6797',
        },
        {
            title: 'XML',
            href: 'c-DOMDocument.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e6886',
            next: 'tocId-d66e6886',
        },
    ],
};

